export default {
  // 公共权限
  common: 'common',
  // 今日数据
  showConsoleTodayAnalysis: 'show_console_today_analysis',
  // 充电站权限
  listChargeStations: 'list_charge_stations',
  exportChargeStations: 'export_charge_stations',
  showChargeStation: 'show_charge_station',
  listChargeStatusesOfChargeStation: 'list_charge_statuses_of_charge_station',
  listOrdersOfChargeStation: 'list_orders_of_charge_station',
  listOrdersStatisticsOfChargeStation: 'list_orders_statistics_of_charge_station',
  listAlarmsOfChargeStation: 'list_alarms_of_charge_station',
  listNvrChannelsOfChargeStation: 'list_nvr_channels_of_charge_station',
  listChargersOfChargeStation: 'list_chargers_of_charge_station',
  listParkingLocksOfChargeStation: 'list_parking_locks_of_charge_station',
  showOrderStatisticsOfChargeStation: 'show_order_statistics_of_charge_station',
  listStationActivitiesOfChargeStation: 'list_station_activities_of_charge_station',
  listModelVersionLogAuditsOfChargeStation: 'list_model_version_log_audits_of_charge_station',
  listSettlementsOfChargeStation: 'list_settlements_of_charge_station',
  createChargeStation: 'create_charge_station',
  updateChargeStation: 'update_charge_station',
  deleteChargeStation: 'delete_charge_station',
  manageStationBillingRules: 'manage_station_billing_rules',
  exportChargeStationQrcodes: 'export_charge_station_qrcodes',

  // 共享站权限
  syncEvChargingStation: 'sync_ev_charging_station',

  // 电站点评
  listStationComments: 'list_charge_station_comments',
  updateStationComment: 'update_charge_station_comment',

  // 充电桩权限
  createChargePoint: 'create_charge_point',
  listChargePoints: 'list_charge_points',
  showChargePoint: 'show_charge_point',
  updateChargePoint: 'update_charge_point',
  deleteChargePoint: 'delete_charge_point',
  exportChargePoints: 'export_charge_points',
  manageChargePointPassword: 'manage_charge_point_password',

  // 充电枪权限
  listChargers: 'list_chargers',
  createCharger: 'create_charger',
  showCharger: 'show_charger',
  updateCharger: 'update_charger',
  listStationActivitiesOfCharger: 'list_station_activities_of_charger',
  listAlarmsOfCharger: 'list_alarms_of_charger',
  listOrdersOfCharger: 'list_orders_of_charger',
  debugChargingOfCharger: 'debug_charging_of_charger',
  showMetricMonitor: 'show_metric_monitor',
  startCharger: 'start_charger',

  listDataCollectors: 'list_data_collectors',

  listModelVersionLogAuditsOfCharger: 'list_model_version_log_audits_of_charger',
  // 订单权限
  listOrders: 'list_orders',
  exportOrders: 'export_orders',
  showOrder: 'show_order',
  showOrderDebugInfo: 'show_order_debug_info',
  statisticsOrders: 'statistics_orders',
  // 充值权限
  listTopUps: 'list_top_ups',
  exportTopUps: 'export_top_ups',

  // 订单账单权限
  listTransactionRecords: 'list_transaction_records',
  // 集团账单权限
  listGroupTransactionRecords: 'list_group_transaction_records',
  // 集团管理员权限
  listGroupAdmins: 'list_group_admins',
  createGroupAdmin: 'create_group_admin',
  updateGroupAdmin: 'update_group_admin',
  // 集团结算类型权限
  updateGroupSettlementType: 'update_group_settlement_type',
  // 集团优惠
  listGroups: 'list_groups',
  createGroup: 'create_group',
  showGroup: 'show_group',
  listGroupApplicationsOfGroup: 'list_group_applications_of_group',
  listOrdersOfGroup: 'list_orders_of_group',
  listGroupTransactionRecordsOfGroup: 'list_group_transaction_records_of_group',
  createTransactionRecord: 'create_transaction_record',
  editGroup: 'update_group',
  deleteGroup: 'delete_group',
  // 优惠券模板权限
  listCouponDefinitions: 'list_coupon_definitions',
  createCouponDefinition: 'create_coupon_definition',
  updateCouponDefinition: 'update_coupon_definition',
  showCouponDefinition: 'show_coupon_definition',
  deleteCouponDefinition: 'delete_coupon_definition',
  // 管理员
  listAdmins: 'list_admins',
  createAdmin: 'create_admin',
  updateAdmin: 'update_admin',
  showAdmin: 'show_admin',
  listOperatedModelVersionLogAuditsOfAdmin: 'list_operated_model_version_log_audits_of_admin',
  deleteAdmin: 'delete_admin',
  // 消息中心
  listNotifications: 'list_messages',
  sendMessage: 'send_message',
  showMessage: 'show_message',
  deleteMessage: 'delete_message',
  // 优惠活动权限
  listTriggers: 'list_triggers',
  showTrigger: 'show_trigger',
  updateTrigger: 'update_trigger',
  createTrigger: 'create_trigger',
  deleteTrigger: 'delete_trigger',
  exportRuleOutcome: 'export_rule_outcome',
  // 优惠券
  listCoupons: 'list_coupons',
  exportCoupons: 'export_coupons',
  // 我的报表权限
  showOrderStatistics: 'show_order_statistics',
  showTopUpStatistics: 'show_top_up_statistics',
  showAlarmStatistics: 'show_alarm_statistics',
  showUserStatistics: 'show_user_statistics',
  showReport: 'show_report',
  showTvWall: 'show_tv_wall',
  // 电桩基本设置
  listEnumerations: 'list_enumerations',
  // 意见反馈
  listFeedbacks: 'list_feedbacks',
  resolvedFeedback: 'resolved_feedback', // 更新为已处理
  // 运营商接入
  listThirdParties: 'list_third_parties',
  createThirdParty: 'create_third_party',
  updateThirdParty: 'update_third_party',
  showThirdParty: 'show_third_party',
  // 报警查询
  listAlarms: 'list_alarms',
  showAlarm: 'show_alarm',
  exportAlarms: 'export_alarms',
  // 刷卡查询
  listMagcardSwipeRecords: 'list_magcard_swipe_records',
  // 费率定制
  listBillingRules: 'list_billing_rules',
  createBillingRule: 'create_billing_rule',
  showBillingRule: 'show_billing_rule',
  showBillingRuleFullInfo: 'show_billing_rule_full_info',
  updateBillingRule: 'update_billing_rule',
  deleteBillingRule: 'delete_billing_rule',
  // 第三方平台商
  listEvcsOperators: 'list_evcs_operators',
  createEvcsOperator: 'create_evcs_operator',
  showEvcsOperator: 'show_evcs_operator',
  updateEvcsOperator: 'update_evcs_operator',
  deleteEvcsOperator: 'delete_evcs_operator',
  // 第三方充电站
  listEvcsStations: 'list_evcs_stations',
  showEvcsStation: 'show_evcs_station',
  // 第三方设备
  listEvcsEquipments: 'list_evcs_equipments',
  showEvcsEquipment: 'show_equipment',
  // 第三方设备订单
  listEvcsOrders: 'list_evcs_orders',
  showEvcsOrder: 'show_evcs_order',
  exportEvcsOrders: 'export_evcs_orders',
  // 我方设备订单
  listEvcsEcmpOrders: 'list_evcs_ecmp_orders',
  exportEvcsEcmpOrders: 'export_evcs_ecmp_orders',
  // 标签管理
  listTags: 'list_tags',
  updateTag: 'update_tag',
  deleteTag: 'delete_tag',
  // 充电站列表
  listEvChargingStations: 'list_ev_charging_stations',
  createEvChargingStation: 'create_ev_charging_station',
  updateEvChargingStation: 'update_ev_charging_station',
  showEvChargingStation: 'show_ev_charging_station',
  deleteEvChargingStation: 'delete_ev_charging_station',
  // 运营商管理
  listServiceProviders: 'list_service_providers',
  showServiceProvider: 'show_service_provider',
  showParentServiceProvider: 'show_parent_service_provider',
  listOrderSettlementsOfServiceProvider: 'list_order_settlements_of_service_provider',
  listSettlementRulesOfServiceProvider: 'list_settlement_rules_of_service_provider',
  listStationSettlementsOfServiceProvider: 'list_station_settlements_of_service_provider',
  listSpWithdrawApplicationsOfServiceProvider: 'list_sp_withdraw_applications_of_service_provider',
  listSpTransactionRecordsOfServiceProvider: 'list_sp_transaction_records_of_service_provider',
  updateServiceProvider: 'update_service_provider',
  createServiceProvider: 'create_service_provider',
  exportServiceProviders: 'export_service_providers',
  deleteServiceProvider: 'delete_service_provider',

  // 礼品卡兑换记录
  listGiftCards: 'list_gift_cards',
  exportGiftCards: 'export_gift_cards',
  createGiftCard: 'create_gift_card',

  // 集团加入申请
  listGroupApplications: 'list_group_applications',
  exportGroupApplications: 'export_group_applications',
  showGroupApplication: 'show_group_application',
  createGroupApplication: 'create_group_application',
  updateGroupApplication: 'update_group_application',

  // 礼品卡管理
  listGiftCardDefinitions: 'list_gift_card_definitions',
  createGiftCardDefinition: 'create_gift_card_definition',
  updateGiftCardDefinition: 'update_gift_card_definition',
  showGiftCardDefinition: 'show_gift_card_definition',
  deleteGiftCardDefinition: 'delete_gift_card_definition',

  // 充电桩
  listEvChargingPiles: 'list_ev_charging_piles',
  createEvChargingPile: 'create_ev_charging_pile',
  updateEvChargingPile: 'update_ev_charging_pile',
  deleteEvChargingPile: 'delete_ev_charging_pile',
  showEvChargingPile: 'show_ev_charging_pile',

  // 爱车认证
  listCars: 'list_cars',
  exportCars: 'export_cars',
  reviewCar: 'review_car',
  createCar: 'create_car',
  deleteCar: 'delete_car',
  updateCar: 'update_car',
  showCar: 'show_car',

  // 枪口
  listEvChargingGuns: 'list_ev_charging_guns',
  createEvChargingGun: 'create_ev_charging_gun',
  updateEvChargingGun: 'update_ev_charging_gun',
  showEvChargingGun: 'show_ev_charging_gun',
  deleteEvChargingGun: 'delete_ev_charging_gun',

  // VIN启动记录
  listVinRecords: 'list_vin_records',

  // 系统配置
  listSystemSettings: 'list_system_settings',
  createSystemSetting: 'create_system_setting',
  showSystem_setting: 'show_system_setting',
  updateSystemSetting: 'update_system_setting',
  deleteSystemSetting: 'delete_system_setting',

  // tags
  createTag: 'create_tag',

  // users
  listUsers: 'list_users',
  exportUsers: 'export_users',
  showUser: 'show_user',
  createUser: 'create_user',
  updateUser: 'update_user',
  deleteUser: 'delete_user',

  // operation_activities
  listOperationActivities: 'list_operation_activities',
  exportOperationActivities: 'export_operation_activities',
  showOperationActivity: 'show_operation_activity',
  createOperationActivity: 'create_operation_activity',
  updateOperationActivity: 'update_operation_activity',
  deleteOperationActivity: 'delete_operation_activity',

  // activity_participations
  listActivityParticipations: 'list_activity_participations',

  // point_records
  listPointRecords: 'list_point_records',
  exportPointRecords: 'export_point_records',
  showPointRecord: 'show_point_record',
  createPointRecord: 'create_point_record',
  updatePointRecord: 'update_point_record',
  deletePointRecord: 'delete_point_record',

  // charging_package_definitions
  listChargingPackageDefinitions: 'list_charging_package_definitions',
  exportChargingPackageDefinitions: 'export_charging_package_definitions',
  showChargingPackageDefinition: 'show_charging_package_definition',
  createChargingPackageDefinition: 'create_charging_package_definition',
  updateChargingPackageDefinition: 'update_charging_package_definition',
  deleteChargingPackageDefinition: 'delete_charging_package_definition',

  // products
  listProducts: 'list_products',
  exportProducts: 'export_products',
  showProduct: 'show_product',
  createProduct: 'create_product',
  updateProduct: 'update_product',
  deleteProduct: 'delete_product',
  // product_orders
  listProductOrders: 'list_product_orders',
  exportProductOrders: 'export_product_orders',
  showProductOrder: 'show_product_order',
  updateProductOrder: 'update_product_order',
  // admin_withdraw_applications
  listAdminWithdrawApplications: 'list_admin_withdraw_applications',
  exportAdminWithdrawApplications: 'export_admin_withdraw_applications',
  showAdminWithdrawApplication: 'show_admin_withdraw_application',
  createAdminWithdrawApplication: 'create_admin_withdraw_application',
  updateAdminWithdrawApplication: 'update_admin_withdraw_application',
  deleteAdminWithdrawApplication: 'delete_admin_withdraw_application',

  // parking_locks
  listParkingLocks: 'list_parking_locks',
  exportParkingLocks: 'export_parking_locks',
  showParkingLock: 'show_parking_lock',
  createParkingLock: 'create_parking_lock',
  updateParkingLock: 'update_parking_lock',
  updateParkingLockStatus: 'update_parking_lock_status',
  deleteParkingLock: 'delete_parking_lock',

  // charging_packages
  listChargingPackages: 'list_charging_packages',
  exportChargingPackages: 'export_charging_packages',

  // station_activities
  listStationActivities: 'list_station_activities',
  showStationActivity: 'show_station_activity',
  // evcs_traces
  listEvcsTraces: 'list_evcs_traces',
  deleteEvcsTrace: 'delete_evcs_trace',
  // evcs_connectors
  listEvcsConnectors: 'list_evcs_connectors',
  exportEvcsConnectors: 'export_evcs_connectors',
  showEvcsConnector: 'show_evcs_connector',
  createEvcsConnector: 'create_evcs_connector',
  updateEvcsConnector: 'update_evcs_connector',
  deleteEvcsConnector: 'delete_evcs_connector',

  // chargers
  // listChargers: 'list_chargers',
  exportChargers: 'export_chargers',
  // showCharger: 'show_charger',
  // createCharger: 'create_charger',
  // updateCharger: 'update_charger',
  deleteCharger: 'delete_charger',

  // alarm_whitelists
  listAlarmWhitelists: 'list_alarm_whitelists',
  exportAlarmWhitelists: 'export_alarm_whitelists',
  showAlarmWhitelist: 'show_alarm_whitelist',
  createAlarmWhitelist: 'create_alarm_whitelist',
  updateAlarmWhitelist: 'update_alarm_whitelist',
  deleteAlarmWhitelist: 'delete_alarm_whitelist',

  // receipt_applications
  listReceiptApplications: 'list_receipt_applications',
  exportReceiptApplications: 'export_receipt_applications',
  showReceiptApplication: 'show_receipt_application',
  createReceiptApplication: 'create_receipt_application',
  updateReceiptApplication: 'update_receipt_application',
  deleteReceiptApplication: 'delete_receipt_application',

  // evcs_charge_records
  listEvcsChargeRecords: 'list_evcs_charge_records',
  exportEvcsChargeRecords: 'export_evcs_charge_records',

  // app_pages
  listAppPages: 'list_app_pages',
  createAppPage: 'create_app_page',
  updateAppPage: 'update_app_page',
  deleteAppPage: 'delete_app_page',
  // parking_relief_codes
  listParkingReliefCodes: 'list_parking_relief_codes',
  exportParkingReliefCodes: 'export_parking_relief_codes',
  createParkingReliefCode: 'create_parking_relief_code',
  deleteParkingReliefCode: 'delete_parking_relief_code',

  // virtual_users
  listVirtualUsers: 'list_virtual_users',
  exportVirtualUsers: 'export_virtual_users',
  showVirtualUser: 'show_virtual_user',
  createVirtualUser: 'create_virtual_user',
  updateVirtualUser: 'update_virtual_user',
  deleteVirtualUser: 'delete_virtual_user',

  // 用户提现审核
  listWithdrawApplications: 'list_withdraw_applications',
  exportWithdrawApplications: 'export_withdraw_applications',
  showWithdrawApplication: 'show_withdraw_application',
  updateWithdrawApplication: 'update_withdraw_application',

  // evcs_notification_orders
  listEvcsNotificationOrders: 'list_evcs_notification_orders',
  exportEvcsNotificationOrders: 'export_evcs_notification_orders',

  // 角色
  listRoles: 'list_roles',
  showRole: 'show_role',
  createRole: 'create_role',
  updateRole: 'update_role',
  deleteRole: 'delete_role',

  // 运营商提现
  listServiceProviderWithdrawApplications: 'list_service_provider_withdraw_applications',
  exportServiceProviderWithdrawApplications: 'export_service_provider_withdraw_applications',
  showServiceProviderWithdrawApplication: 'show_service_provider_withdraw_application',
  createServiceProviderWithdrawApplication: 'create_service_provider_withdraw_application',
  reviewServiceProviderWithdrawApplication: 'review_service_provider_withdraw_application',
  spWithdrawApplicationsMonthlySummary: 'sp_withdraw_applications_monthly_summary',

  // 工作台信息
  // service_provider_transaction_records
  listServiceProviderTransactionRecords: 'list_service_provider_transaction_records',
  exportServiceProviderTransactionRecords: 'export_service_provider_transaction_records',
  createServiceProviderTransactionRecord: 'create_service_provider_transaction_record',

  //

  // 数据版本日志
  listModelVersionLogAudits: 'list_model_version_log_audits',
  exportModelVersionLogAudits: 'export_model_version_log_audits',
  showModelVersionLogAudit: 'show_model_version_log_audit',

  // pickup_locations
  listPickupLocations: 'list_pickup_locations',
  exportPickupLocations: 'export_pickup_locations',
  showPickupLocation: 'show_pickup_location',
  createPickupLocation: 'create_pickup_location',
  updatePickupLocation: 'update_pickup_location',
  deletePickupLocation: 'delete_pickup_location',

  // 报警
  updateAlarmsStatus: 'update_alarms_status',
  // settlement_rules
  listSettlementRules: 'list_settlement_rules',
  exportSettlementRules: 'export_settlement_rules',
  showSettlementRule: 'show_settlement_rule',
  createSettlementRule: 'create_settlement_rule',
  updateSettlementRule: 'update_settlement_rule',
  deleteSettlementRule: 'delete_settlement_rule',

  // ev_charging_station_settlements
  listEvChargingStationSettlements: 'list_ev_charging_station_settlements',
  exportEvChargingStationSettlements: 'export_ev_charging_station_settlements',
  showEvChargingStationSettlement: 'show_ev_charging_station_settlement',
  createEvChargingStationSettlement: 'create_ev_charging_station_settlement',
  deleteEvChargingStationSettlement: 'delete_ev_charging_station_settlement',

  // 订单结算
  listOrderSettlements: 'list_order_settlements',
  exportOrderSettlements: 'export_order_settlements',
  showOrderSettlement: 'show_order_settlement',

  //订单预结算
  createOrderPreSettlement: 'create_order_pre_settlement',

  // task_definitions
  listTaskDefinitions: 'list_task_definitions',
  exportTaskDefinitions: 'export_task_definitions',
  showTaskDefinition: 'show_task_definition',
  createTaskDefinition: 'create_task_definition',
  updateTaskDefinition: 'update_task_definition',
  deleteTaskDefinition: 'delete_task_definition',

  // nvr_channels
  listNvrChannels: 'list_nvr_channels',
  exportNvrChannels: 'export_nvr_channels',
  showNvrChannel: 'show_nvr_channel',
  createNvrChannel: 'create_nvr_channel',
  updateNvrChannel: 'update_nvr_channel',
  deleteNvrChannel: 'delete_nvr_channel',

  // third_party_service_traces
  listThirdPartyServiceTraces: 'list_third_party_service_traces',

  // tasks
  listTasks: 'list_tasks',
  exportTasks: 'export_tasks',

  // parking_reliefs
  listParkingReliefs: 'list_parking_reliefs',
  exportParkingReliefs: 'export_parking_reliefs',
  showParkingRelief: 'show_parking_relief',
  createParkingRelief: 'create_parking_relief',
  updateParkingRelief: 'update_parking_relief',
  deleteParkingRelief: 'delete_parking_relief',
  // inserting_gun_start_records
  listInsertingGunStartRecords: 'list_inserting_gun_start_records',
  exportInsertingGunStartRecords: 'export_inserting_gun_start_records',
  showInsertingGunStartRecord: 'show_inserting_gun_start_record',
  createInsertingGunStartRecord: 'create_inserting_gun_start_record',
  updateInsertingGunStartRecord: 'update_inserting_gun_start_record',
  deleteInsertingGunStartRecord: 'delete_inserting_gun_start_record',
  // device_orders
  listDeviceOrders: 'list_device_orders',
  exportDeviceOrders: 'export_device_orders',
  showDeviceOrder: 'show_device_order',

  // posts
  listPosts: 'list_posts',
  exportPosts: 'export_posts',
  showPost: 'show_post',
  createPost: 'create_post',
  updatePost: 'update_post',
  deletePost: 'delete_post',

  // product_return_applications
  listProductReturnApplications: 'list_product_return_applications',
  exportProductReturnApplications: 'export_product_return_applications',
  showProductReturnApplication: 'show_product_return_application',
  updateProductReturnApplication: 'update_product_return_application',

  // device_test_reports
  listDeviceTestReports: 'list_device_test_reports',
  exportDeviceTestReports: 'export_device_test_reports',
  showDeviceTestReport: 'show_device_test_report',
  // magcards
  listMagcards: 'list_magcards',
  exportMagcards: 'export_magcards',
  showMagcard: 'show_magcard',
  createMagcard: 'create_magcard',
  updateMagcard: 'update_magcard',
  deleteMagcard: 'delete_magcard',
  // parking_relief_records
  listParkingReliefRecords: 'list_parking_relief_records',
  exportParkingReliefRecords: 'export_parking_relief_records',

  // idle_fee_bills
  listIdleFeeBills: 'list_idle_fee_bills',
  exportIdleFeeBills: 'export_idle_fee_bills',
  showIdleFeeBill: 'show_idle_fee_bill',
  deleteIdleFeeBill: 'delete_idle_fee_bill',
  // idle_fees
  listIdleFees: 'list_idle_fees',
  showIdleFee: 'show_idle_fee',
  createIdleFee: 'create_idle_fee',
  updateIdleFee: 'update_idle_fee',
  deleteIdleFee: 'delete_idle_fee',

  // billing_rule_timers
  listBillingRuleTimers: 'list_billing_rule_timers',
  exportBillingRuleTimers: 'export_billing_rule_timers',
  showBillingRuleTimer: 'show_billing_rule_timer',
  createBillingRuleTimer: 'create_billing_rule_timer',
  updateBillingRuleTimer: 'update_billing_rule_timer',
  deleteBillingRuleTimer: 'delete_billing_rule_timer',
  // idle_fee_bill_settlements
  listIdleFeeBillSettlements: 'list_idle_fee_bill_settlements',
  exportIdleFeeBillSettlements: 'export_idle_fee_bill_settlements',
  showIdleFeeBillSettlement: 'show_idle_fee_bill_settlement',

  // start_appointments
  listStartAppointments: 'list_start_appointments',
  exportStartAppointments: 'export_start_appointments',
  showStartAppointment: 'show_start_appointment',
  createStartAppointment: 'create_start_appointment',
  updateStartAppointment: 'update_start_appointment',
  deleteStartAppointment: 'delete_start_appointment',

  // charging_card_definitions
  listChargingCardDefinitions: 'list_charging_card_definitions',
  exportChargingCardDefinitions: 'export_charging_card_definitions',
  showChargingCardDefinition: 'show_charging_card_definition',
  createChargingCardDefinition: 'create_charging_card_definition',
  updateChargingCardDefinition: 'update_charging_card_definition',
  deleteChargingCardDefinition: 'delete_charging_card_definition',
  // charging_cards
  listChargingCards: 'list_charging_cards',
  exportChargingCards: 'export_charging_cards',
  createChargingCard: 'create_charging_card',
  deleteChargingCard: 'delete_charging_card',
  showChargingCard: 'show_charging_card',

  // charging_card_consumption_records
  listChargingCardConsumptionRecords: 'list_charging_card_consumption_records',
  exportChargingCardConsumptionRecords: 'export_charging_card_consumption_records',
  showChargingCardConsumptionRecord: 'show_charging_card_consumption_record',

  // vip_members
  listVipMembers: 'list_vip_members',
  showVipMember: 'show_vip_member',
  exportVipMembers: 'export_vip_members',
  updateMembership: 'update_membership',
  showMembership: 'show_membership',

  // vip_charge_stations
  listVipChargeStations: 'list_vip_charge_stations',
  updateVipChargeStation: 'update_vip_charge_station',
  deleteVipChargeStation: 'delete_vip_charge_station',
  createVipChargeStation: 'create_vip_charge_station',

  // billing_rule_temperature_timers
  listBillingRuleTemperatureTimers: 'list_billing_rule_temperature_timers',
  exportBillingRuleTemperatureTimers: 'export_billing_rule_temperature_timers',
  showBillingRuleTemperatureTimer: 'show_billing_rule_temperature_timer',
  createBillingRuleTemperatureTimer: 'create_billing_rule_temperature_timer',
  updateBillingRuleTemperatureTimer: 'update_billing_rule_temperature_timer',
  deleteBillingRuleTemperatureTimer: 'delete_billing_rule_temperature_timer',

  // charge_station_special_billing_rules
  listStationSpecialBillingRules: 'list_station_special_billing_rules',

  // bank_accounts
  listBankAccounts: 'list_bank_accounts',
  exportBankAccounts: 'export_bank_accounts',
  showBankAccount: 'show_bank_account',
  createBankAccount: 'create_bank_account',
  updateBankAccount: 'update_bank_account',
  deleteBankAccount: 'delete_bank_account',

  // settlement_discounts
  listSettlementDiscounts: 'list_settlement_discounts',
  showSettlementDiscount: 'show_settlement_discount',
  createSettlementDiscount: 'create_settlement_discount',
  updateSettlementDiscount: 'update_settlement_discount',
  deleteSettlementDiscount: 'delete_settlement_discount',

  // vin_blacklists
  listVinBlacklists: 'list_vin_blacklists',
  exportVinBlacklists: 'export_vin_blacklists',
  showVinBlacklist: 'show_vin_blacklist',
  createVinBlacklist: 'create_vin_blacklist',
  updateVinBlacklist: 'update_vin_blacklist',
  deleteVinBlacklist: 'delete_vin_blacklist',
  // order_refunds
  listOrderRefunds: 'list_order_refunds',
  exportOrderRefunds: 'export_order_refunds',
  showOrderRefund: 'show_order_refund',
  createOrderRefund: 'create_order_refund',
  updateOrderRefund: 'update_order_refund',

  // work_orders
  listWorkOrders: 'list_work_orders',
  exportWorkOrders: 'export_work_orders',
  showWorkOrder: 'show_work_order',
  createWorkOrder: 'create_work_order',
  updateWorkOrder: 'update_work_order',
  deleteWorkOrder: 'delete_work_order',
  updateWorkOrderPayment: 'update_work_order_payment',
  // alarm_notification_rules
  listAlarmNotificationRules: 'list_alarm_notification_rules',
  showAlarmNotificationRule: 'show_alarm_notification_rule',
  createAlarmNotificationRule: 'create_alarm_notification_rule',
  updateAlarmNotificationRule: 'update_alarm_notification_rule',
  deleteAlarmNotificationRule: 'delete_alarm_notification_rule',

  // notification_records
  listNotificationRecords: 'list_notification_records',
  showNotificationRecord: 'show_notification_record',

  // notification_subscriptions
  listNotificationSubscriptions: 'list_notification_subscriptions',
  showNotificationSubscription: 'show_notification_subscription',
  createNotificationSubscription: 'create_notification_subscription',
  updateNotificationSubscription: 'update_notification_subscription',
  deleteNotificationSubscription: 'delete_notification_subscription',

  // subscription_trigger_records
  listSubscriptionTriggerRecords: 'list_subscription_trigger_records',

  // advertisements
  listAdvertisements: 'list_advertisements',
  showAdvertisement: 'show_advertisement',
  createAdvertisement: 'create_advertisement',
  updateAdvertisement: 'update_advertisement',
  deleteAdvertisement: 'delete_advertisement',

  // invoices
  listInvoices: 'list_invoices',
  exportInvoices: 'export_invoices',
  showInvoice: 'show_invoice',
  deleteInvoice: 'delete_invoice',
  createInvoices: 'create_invoices',

  // advertising_spaces
  listAdvertisingSpaces: 'list_advertising_spaces',

  // charge_channels
  listChargeChannels: 'list_charge_channels',
  showChargeChannel: 'show_charge_channel',
  createChargeChannel: 'create_charge_channel',
  updateChargeChannel: 'update_charge_channel',
  deleteChargeChannel: 'delete_charge_channel',

  // Enumeration
  createEnumeration: 'create_enumeration',
  updateEnumeration: 'update_enumeration',
  deleteEnumeration: 'delete_enumeration',

  // equipment_productions
  listEquipmentProductions: 'list_equipment_productions',
  exportEquipmentProductions: 'export_equipment_productions',
  showEquipmentProduction: 'show_equipment_production',
  createEquipmentProduction: 'create_equipment_production',
  updateEquipmentProduction: 'update_equipment_production',
  deleteEquipmentProduction: 'delete_equipment_production',
  // equipment_dispatches
  listEquipmentDispatches: 'list_equipment_dispatches',
  exportEquipmentDispatches: 'export_equipment_dispatches',
  showEquipmentDispatch: 'show_equipment_dispatch',
  createEquipmentDispatch: 'create_equipment_dispatch',
  updateEquipmentDispatch: 'update_equipment_dispatch',
  deleteEquipmentDispatch: 'delete_equipment_dispatch',
  // discount_settlement_rules
  listDiscountSettlementRules: 'list_discount_settlement_rules',
  exportDiscountSettlementRules: 'export_discount_settlement_rules',
  showDiscountSettlementRule: 'show_discount_settlement_rule',
  createDiscountSettlementRule: 'create_discount_settlement_rule',
  updateDiscountSettlementRule: 'update_discount_settlement_rule',
  deleteDiscountSettlementRule: 'delete_discount_settlement_rule',

  // discount_settlements
  listOrderDiscountSettlements: 'list_order_discount_settlements',
  exportOrderDiscountSettlements: 'export_order_discount_settlements',
  showOrderDiscountSettlements: 'show_order_discount_settlement',

  // material_templates
  listMaterialTemplates: 'list_material_templates',
  exportMaterialTemplates: 'export_material_templates',
  showMaterialTemplate: 'show_material_template',
  createMaterialTemplate: 'create_material_template',
  updateMaterialTemplate: 'update_material_template',
  deleteMaterialTemplate: 'delete_material_template',
  // materials
  listMaterials: 'list_materials',
  exportMaterials: 'export_materials',
  showMaterial: 'show_material',
  createMaterial: 'create_material',
  updateMaterial: 'update_material',
  deleteMaterial: 'delete_material',

  // charging_package_settlement_rules
  listChargingPackageSettlementRules: 'list_charging_package_settlement_rules',
  exportChargingPackageSettlementRules: 'export_charging_package_settlement_rules',
  showChargingPackageSettlementRule: 'show_charging_package_settlement_rule',
  createChargingPackageSettlementRule: 'create_charging_package_settlement_rule',
  updateChargingPackageSettlementRule: 'update_charging_package_settlement_rule',
  deleteChargingPackageSettlementRule: 'delete_charging_package_settlement_rule',

  // charging_package_settlements
  listChargingPackageSettlements: 'list_charging_package_settlements',
  exportChargingPackageSettlements: 'export_charging_package_settlements',
  showChargingPackageSettlement: 'show_charging_package_settlement',
  // idle_fee_settlement_rules
  showIdleFeeSettlementRule: 'show_idle_fee_settlement_rule',
  updateIdleFeeSettlementRule: 'update_idle_fee_settlement_rule'
}
